"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchivedPlanNames = exports.PlanNames = void 0;
var PlanNames;
(function (PlanNames) {
    PlanNames["free"] = "free";
    PlanNames["pro1"] = "pro#1";
    PlanNames["pro5"] = "pro#5";
    PlanNames["pro10"] = "pro#10";
    PlanNames["guru"] = "guru";
})(PlanNames || (exports.PlanNames = PlanNames = {}));
var ArchivedPlanNames;
(function (ArchivedPlanNames) {
    ArchivedPlanNames["#1"] = "#1";
    ArchivedPlanNames["#3"] = "#3";
    ArchivedPlanNames["#7"] = "#7";
    ArchivedPlanNames["#10"] = "#10";
})(ArchivedPlanNames || (exports.ArchivedPlanNames = ArchivedPlanNames = {}));
//# sourceMappingURL=plan-names.enum.js.map